var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.341 28.916C42.336 40.97 30.128 48.306 18.073 45.3 6.023 42.295-1.313 30.086 1.693 18.033 4.697 5.978 16.906-1.36 28.957 1.647c12.054 3.005 19.39 15.215 16.384 27.27Z",
    fill: "url(#21_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.414 20.294c.448-2.993-1.831-4.603-4.948-5.677l1.011-4.055-2.469-.615-.984 3.948c-.649-.161-1.316-.314-1.978-.465l.992-3.975-2.468-.615-1.012 4.054a82.95 82.95 0 0 1-1.576-.37l.003-.013-3.405-.85-.656 2.636s1.831.42 1.793.446c1 .25 1.18.912 1.15 1.436l-1.152 4.62c.07.018.158.043.257.083l-.261-.065-1.614 6.472c-.123.304-.433.76-1.132.587.025.035-1.794-.448-1.794-.448l-1.226 2.825 3.213.801c.598.15 1.183.307 1.76.455l-1.022 4.102 2.466.615 1.012-4.059c.673.183 1.327.352 1.967.51l-1.008 4.04 2.469.616 1.021-4.095c4.21.797 7.375.476 8.708-3.332 1.073-3.065-.054-4.834-2.269-5.987 1.613-.372 2.828-1.433 3.152-3.625Zm-5.64 7.91c-.763 3.066-5.925 1.408-7.598.993l1.356-5.435c1.673.418 7.04 1.245 6.242 4.442Zm.764-7.954c-.696 2.789-4.992 1.372-6.386 1.025l1.229-4.93c1.393.348 5.882.996 5.157 3.905Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "21_svg__a",
    x1: 1.02,
    y1: 0.973,
    x2: 1.02,
    y2: 45.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.b6d78cc17f6f7e590cce2a157ebef0d8.svg";
export { ForwardRef as ReactComponent };